import { useTranslation } from "react-i18next";

function StatisticsCircles(props) {
  const { t, i18n } = useTranslation();
  const averageScore = props.averageScore;
  const countReviews = props.countReviews;
  const npsCount = props.npsCount;

  return (
    <div>
      <div className="row statisticsCircles">
        <div className="statisticsCircles-grid">
          <div className="item">
            <div>
              <span>{countReviews}</span>
            </div>
            <p>
              {t("admin.common.review", {
                count: Math.round(countReviews),
              })}
            </p>
          </div>
        </div>

        <div className="statisticsCircles-grid">
          <div className="item">
            <div>
              <span>
                {averageScore}
                <sup>/5</sup>
              </span>
            </div>
            <p>{t("admin.common.avgRat")}</p>
          </div>
        </div>
        {npsCount > 0 ? (
          <div className="statisticsCircles-grid">
            <div className="item">
              <div>
                <span>{npsCount} %</span>
              </div>
              <p>{t("admin.common.custRef")} </p>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default StatisticsCircles;
